import { required, requiredWhen, validateError } from "../../../../../utils/validate";
import {
    createFieldCheckbox,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import store from "../../../../../store/index";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { initUseForm } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import i18n from "../../../../../i18n";
import { defineAsyncComponent, reactive, toRaw, watch } from "vue";
import { addModal } from "../../../../../app.logic";
import lodash from "lodash";
import { modalStyleForm } from "../../../../../utils/constant";

export const { isLoading, setIsLoading } = createLoading();
export const OperatorForm = defineAsyncComponent(() => import('./OperatorForm'));

export const loadForm = ({ data, props }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => {
            if (page?.data[0]?.mathSymbol) {
                data.mathSymbol = data.mathSymbolSelectItems.find(it => it.mathSymbol == form.mathSymbol);
            }
            initUseForm({ data, page });
        })
        .finally(() => setIsLoading(false));
};

export const createForm = () => {
    return {
        refLabTopic: null,
        n: null,
        c: null,
        m: null,
        mUpper: null,
        mathSymbol: null,
        operatorValue: null,
        isAccept: null,
        isDetected: null
    };
};

export const createRules = ({ props, data }) => {
    const { parent } = props;
    return {
        refLabTopic: [required],
        n: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && (data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'n c m M' || data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key === 'Detected') })],
        c: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'n c m M' })],
        m: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'n c m M' })],
        mUpper: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key == 'n c m M' })],
        mathSymbol: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key === 'Operator' })],
        operatorValue: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key === 'Operator' })],
        isAccept: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key === 'Accept/Reject' })],
        isDetected: [requiredWhen({ when: () => data?.useForm?.modelRef?.isManualStd && !parent?.refExtCenterType && data?.useForm?.modelRef?.refLabTopic?.refLabFormula?.key === 'Detected' })]
    };
};


export const openModalForm = ({ props, items, callBack }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '40%',
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t('lab.formula.operator'),
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        if (items) {
                            items.push(record);
                        } else {
                            lodash.merge(props.form, record);
                            callBack?.();
                        }
                        options.bind.onCancel();
                    });
            }
        }),
        render: () => <OperatorForm ref={(e) => {
            if (e) refs.form = e;
        }} {...props}></OperatorForm>
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};


export const createField = ({ props, data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const { parent, disableTopic, labTypeKey, whereTopic, visibleTopic, viewOnly } = props;
    const fields = [
        createFieldSelect({
            visible: () => visibleTopic,
            key: 'refLabTopic',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.labTopic'),
            inputProp: () => ({
                value: modelRef.refLabTopic,
                'onUpdate:value': value => {
                    modelRef.refLabTopic = value;
                },
                disabled: viewOnly || disableTopic,
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/labTopic/cacheFindAll', {
                    searchQuery,
                    labTypeKey: labTypeKey,
                    where: [...whereTopic]
                }),
                renderLabel: ({ item }) => <span>{item.name}</span>
            })
        }),
        createFieldRadioGroup({
            visible: () => visibleTopic && !parent?.refExtCenterType && modelRef.refLabTopic && modelRef.mode === "create",
            key: `isManualStd`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("lab.labStandardTopic"),
            inputProp: () => {
                const options = [{ label: "อ้างอิงตารางมาตรฐาน", id: "F", flag: false}, { label: "กำหนดเอง", id: "T", flag: true}];
                return {
                    value: options.find(d=>d.flag === modelRef.isManualStd),
                    "onUpdate:value": value => {
                        modelRef.isManualStd = value?.flag
                    },
                    disabled: viewOnly,
                    list: () => (options),
                    optLabel: "label"
                };
            }
        }),
        createFieldInputNumber({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType &&
                (
                    modelRef.refLabTopic?.refLabFormula?.key === 'n c m M' || modelRef.refLabTopic?.refLabFormula?.key == 'Detected'
                ),
            key: 'n',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.n'),
            inputProp: () => ({
                value: modelRef.n,
                'onUpdate:value': value => modelRef.n = value,
                disabled: viewOnly,
                comma: false,
                maxDecimal: 1000,
                allowPrecision: true
            })
        }),
        createFieldInputNumber({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'n c m M',
            key: 'c',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.c'),
            inputProp: () => ({
                value: modelRef.c,
                'onUpdate:value': value => modelRef.c = value,
                disabled: viewOnly,
                comma: false,
                maxDecimal: 1000,
                allowPrecision: true
            })
        }),
        createFieldInputNumber({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'n c m M',
            key: 'm',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.m'),
            inputProp: () => ({
                value: modelRef.m,
                'onUpdate:value': value => modelRef.m = value,
                disabled: viewOnly,
                comma: false,
                maxDecimal: 1000,
                allowPrecision: true
            })
        }),
        createFieldInputNumber({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'n c m M',
            key: 'mUpper',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.mUpper'),
            inputProp: () => ({
                value: modelRef.mUpper,
                'onUpdate:value': value => modelRef.mUpper = value,
                disabled: viewOnly,
                comma: false,
                maxDecimal: 1000,
                allowPrecision: true
            })
        }),
        createFieldSelect({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'Operator',
            key: 'mathSymbol',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.operator'),
            inputProp: () => ({
                value: data.mathSymbol,
                'onUpdate:value': value => {
                    data.mathSymbol = value;
                    modelRef.mathSymbol = value.mathSymbol
                },
                disabled: viewOnly,
                list: () => data.mathSymbolSelectItems,
                optKey: 'mathSymbol',
                optLabel: 'mathSymbol'
            }),
        }),
        createFieldInputNumber({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'Operator',
            key: 'operatorValue',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.operatorValue'),
            inputProp: () => ({
                value: modelRef.operatorValue,
                'onUpdate:value': value => modelRef.operatorValue = value,
                disabled: viewOnly,
                comma: false,
                maxDecimal: 1000,
                allowPrecision: true,
                maxPrecision: 3,
            })
        }),
        createFieldCheckbox({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'Accept/Reject',
            key: 'isAccept',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.isAccept'),
            inputProp: () => ({
                checked: modelRef.isAccept,
                'onUpdate:checked': checked => modelRef.isAccept = checked,
                disabled: viewOnly
            })
        }),
        createFieldCheckbox({
            visible: () => modelRef.isManualStd && !parent?.refExtCenterType && modelRef.refLabTopic?.refLabFormula?.key === 'Detected',
            key: 'isDetected',
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t('lab.formula.isDetected'),
            inputProp: () => ({
                checked: modelRef.isDetected,
                'onUpdate:checked': checked => modelRef.isDetected = checked,
                disabled: viewOnly
            })
        })
    ];
    return fields;
};

export const initForm = ({ props, data }) => {
    data.form = createForm();
    data.rules = createRules({ props, data });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data });
    watch(
        () => data.useForm.modelRef.refLabTopic,
        (value) => {
            if (!value) {
                data.useForm.modelRef.n = null;
                data.useForm.modelRef.c = null;
                data.useForm.modelRef.m = null;
                data.useForm.modelRef.mUpper = null;
                data.useForm.modelRef.mathSymbol = null;
                data.mathSymbol = null;
                data.useForm.modelRef.operatorValue = null;
                data.useForm.modelRef.isAccept = null;
                data.useForm.modelRef.isDetected = null;
            } else {
                if (value.refLabFormula.key == 'n c m M') {
                    data.useForm.modelRef.mathSymbol = null;
                    data.mathSymbol = null;
                    data.useForm.modelRef.operatorValue = null;
                    data.useForm.modelRef.isAccept = null;
                    data.useForm.modelRef.isDetected = null;
                } else if (value.refLabFormula.key === 'Operator') {
                    data.useForm.modelRef.n = data.useForm.modelRef.refLabTopic.sub;
                    data.useForm.modelRef.c = null;
                    data.useForm.modelRef.m = null;
                    data.useForm.modelRef.mUpper = null;
                    data.useForm.modelRef.isAccept = null;
                    data.useForm.modelRef.isDetected = null;
                } else if (value.refLabFormula.key === 'Accept/Reject') {
                    data.useForm.modelRef.n = data.useForm.modelRef.refLabTopic.sub;
                    data.useForm.modelRef.c = null;
                    data.useForm.modelRef.m = null;
                    data.useForm.modelRef.mUpper = null;
                    data.useForm.modelRef.mathSymbol = null;
                    data.mathSymbol = null;
                    data.useForm.modelRef.operatorValue = null;
                    data.useForm.modelRef.isDetected = null;
                } else if (value.refLabFormula.key === 'Detected') {
                    // data.useForm.modelRef.n = data.useForm.modelRef.refLabTopic.sub;
                    data.useForm.modelRef.c = null;
                    data.useForm.modelRef.m = null;
                    data.useForm.modelRef.mUpper = null;
                    data.useForm.modelRef.mathSymbol = null;
                    data.mathSymbol = null;
                    data.useForm.modelRef.operatorValue = null;
                    data.useForm.modelRef.isAccept = null;
                }
            }
        },
        { flush: 'post' }
    );
    loadForm({ data, props });
};